import { createGenericContext } from './generic-context';

export interface LoginContextState {
    userProviders: string[];
}

const GenericContext = createGenericContext<LoginContextState>({
    userProviders: [],
});

export const LoginContextProvider = GenericContext.Provider;

export const useLoginContext = GenericContext.useGenericContext;

export const useLoginUserProviders = () => {
    const { data } = useLoginContext();

    return data.userProviders;
};
